// const source = 'podsDataTable'

function uploadModulistica () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'agenti-upload-modulistica',
      title: 'Upload Modulistica',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': uploadModulistica,
}
